/* eslint-disable react-hooks/rules-of-hooks */
// isBrowser check causes useState to run conditionally
import { useState } from "react";
import { isBrowser } from "../../utils";

const useSessionStorage = (key: string): [string | null, (value: string) => void] => {
    if (!isBrowser()) {
        return [null, () => {}];
    }
    // State to store our value
    // Pass initial state function to useState so logic is only executed once
    const [storedValue, setStoredValue] = useState(() => (
        // Get from session storage by key
        window.sessionStorage.getItem(key)
    ));
    // Return a wrapped version of useState's setter function that
    // persists the new value to sessionStorage.
    const setValue = (value: string) => {
        // Save state
        setStoredValue(value);
        // Save to session storage
        window.sessionStorage.setItem(key, value);
    };
    return [storedValue, setValue];
};

export { useSessionStorage as default, useSessionStorage };
